var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComblesAmenages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.44 30.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c7a00d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.43,30.61c-.59-.6-2.19-2.14-.99-2.8L46.93.08l.34-.08,46.99,28.32.19.12-1.22,2.3c-.16.04-1.31-.81-1.55-.96,0-.25-.39-.43-.57-.56-.25-.17-.76-.63-1.05-.52-.04-.03-.07-.08-.11-.11,0,0,.03-.14-.07-.22-.67-.53-1.53-1.04-2.3-1.4l-.26-.32-80.24.31.27-.07M77.86,25.13c2.44.06,4.9-.08,7.34,0,.31.01.49.25.43-.11l-8.63-4.86c-.08-.12-.21-.15-.32-.22l-12.3-7.23c-.1-.06-.2-.14-.32-.22.03-.26-.42-.4-.62-.52-1.51-.9-3.14-1.96-4.68-2.77-.15-.08-.24-.21-.42-.06-.1-.06-.2-.14-.32-.22.06-.27-.14-.22-.28-.3-.32-.19-.87-.68-1.23-.56-.1-.06-.2-.14-.32-.22.06-.27-.14-.22-.28-.3-.32-.19-.87-.68-1.23-.56-.29-.17-.57-.37-.86-.54.06-.27-.14-.22-.28-.3-.32-.19-.87-.68-1.23-.56-.1-.06-.2-.14-.32-.22.06-.27-.14-.22-.28-.3-.32-.19-.87-.68-1.23-.56-.1-.06-.2-.14-.32-.22.06-.27-.14-.22-.28-.3-.32-.19-.87-.68-1.23-.56-.1-.05-.19-.14-.32-.22.06-.27-.14-.22-.28-.3-.71-.44-.61-.57-1.33-.13-11.29,6.88-22.76,13.55-34.2,20.17-.5.29-1.01.57-1.51.86-.1.06-.2.14-.32.22-.49.3-1.34.61-1.77.99-.13.12-.16.12-.17.31,0,.06,0,.21,0,.22.08.06,1.73.01,2,0,12.63-.39,25.37-.17,38.02-.22.14,0,.29,0,.43,0,1.04,0,2.09,0,3.13,0,1.19,0,2.37,0,3.56,0,1.9,0,3.85-.09,5.72-.11.11,0,.22,0,.32,0s.31,0,.43,0c3.38-.03,6.76.02,10.14,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.95 26.97 8.22 26.64 87.3 26.64 87.57 26.97 7.95 26.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.37,12.73l12.3,7.23c-4.08-2.41-8.21-4.82-12.3-7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.33,9.17c.18-.15.27-.02.42.06,1.54.81,3.17,1.86,4.68,2.77.19.12.64.26.62.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.65,24.06c.06.27-.14.22-.28.3-.55.34-1.1.68-1.66.99.02-.19.04-.19.17-.31.42-.38,1.28-.69,1.77-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.5,8.09c.36-.12.91.36,1.23.56.14.09.34.04.28.3-.5-.29-1.01-.57-1.51-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.66,7.01c.36-.12.91.36,1.23.56.14.09.34.04.28.3-.5-.29-1.01-.57-1.51-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.29,5.61c.36-.12.91.36,1.23.56.14.09.34.04.28.3-.5-.29-1.01-.57-1.51-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.46,4.53c.36-.12.91.36,1.23.56.14.09.34.04.28.3-.5-.29-1.01-.57-1.51-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.62,3.45c.36-.12.91.36,1.23.56.14.09.34.04.28.3-.5-.29-1.01-.58-1.51-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.68,2.8c.73-.44.62-.31,1.33.13.14.09.35.04.28.3-.5-.27-1.05-.64-1.62-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.32,25.24c-.12,0-.32,0-.43,0h.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freB15.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.99,16.68c-.1.11-.16.21-.17.37-.14,1.46.11,3.13,0,4.61h-12.79s-.21.19-.21.21v3.11s2,0,2,0v-1.33h11v1.33s2,0,2,0v-8.3s-1.83,0-1.83,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.16,21h8.67s0-2.12,0-2.12c0-.07-.27-.24-.37-.21-1.97.22-4.6-.29-6.49.02-.95.16-1.92,1.32-1.81,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.18,18.36c-1.47-.3-2.35,1.5-1.15,2.39s2.65-.47,1.98-1.72c-.14-.25-.54-.61-.83-.67Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "tv8AR5.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.44,6.47l.11.1c.4,1.8.62,3.66.96,5.48.05.11-.16.35-.24.35h-1.94v1.95s-.13.14-.15.15c-.15.07-.44-.02-.44-.18v-1.91h-.74v11.45c.47-.04.93.07,1.26.43.25.28.6,1.11.02,1.17-1,.1-2.16-.08-3.18,0-.44-.05-.24-.7-.1-.95.29-.5.85-.69,1.41-.64v-11.45h-3.27c-.06,0-.2-.17-.24-.22v-.19c.43-1.66.45-3.61.89-5.24.04-.14.07-.19.18-.28h5.47ZM45.56,11.77h.67l.48-4.71-.34.02-.81,4.69ZM46.82,11.77h.81l.18-4.71h-.48s-.52,4.71-.52,4.71ZM48.96,7.07h-.52l-.18,4.71h.89l-.18-4.71ZM49.77,11.77h.81l-.52-4.7h-.48s.18,4.7.18,4.7ZM51.84,11.77l-.81-4.69-.34-.02.48,4.71h.67ZM49.88,24.85c-.03-.13-.25-.32-.37-.35-.17-.04-1.41-.05-1.6,0-.13.03-.36.22-.4.36h2.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MJ9Lbl.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.56,25.15c-.54-.17-.67-.85-.17-1.15-.15-.06-.31-.08-.46-.15-.44-.19-.84-.62-.98-1.08-.06-.2-.05-.38-.09-.56-.08-.39-.21-.78-.29-1.17-.07-.17-.31-.21-.46-.32-.72-.55-.68-1.66.11-2.12.7-.41,1.68-.05,2.18.53.4.47.53,1.07.5,1.68.39-.11.78-.21,1.18-.26.94-.13,2.04-.13,2.98-.02.47.05.93.15,1.37.29-.03-.56.07-1.08.39-1.54.67-.94,2.28-1.28,2.82-.04l.09.29v.36c-.08.36-.27.68-.58.88-.13.09-.32.11-.38.27-.08.39-.21.78-.29,1.17-.04.19-.03.36-.09.56-.16.51-.6.95-1.11,1.13-.06.02-.32.06-.34.1.5.31.37.99-.17,1.15h-.27c-.57-.17-.65-.81-.19-1.17h-5.29c.45.36.37,1-.19,1.17h-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.76,19.86c-.31-.03-.62-.09-.93-.12-.64-.05-1.35-.06-1.99-.02-.42.03-.83.09-1.25.14-.21-.9-.83-1.64-1.69-1.99,0-.91-.11-1.81.21-2.68,1.23-3.29,5.93-3.28,7.13.02.32.86.2,1.74.21,2.64-.01.04-.24.12-.3.16-.71.4-1.2,1.05-1.39,1.85Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComblesAmenages);
export default __webpack_public_path__ + "static/media/combles-amenages.fd094e77951f9c2a5ff1298188db9951.svg";
export { ForwardRef as ReactComponent };